<div class="swipe-item {{itemClass}}" (swipeleft)="swipeleft($event)" (swipe)="swipeleft($event)" >
  <ng-template #defaultEdit>
    edit
  </ng-template>
  <ng-template #defaultDel>
    del
  </ng-template>
  <ng-template #defaultMark>
    <div class="yes-marker"></div>
  </ng-template>
  <ng-template #defaultNotMark>
    <div class="not-marker"></div>
  </ng-template>

  <ng-template #defaultCustom>
    <div data-id="{{idElement}}" class="text truncate">{{inside.title}}</div>
    <div data-id="{{idElement}}" class="small truncate">{{inside.subTitle}}</div>
  </ng-template>


  <div [ngClass]="{isWeb, 'active':(result)}" data-id="{{idElement}}"
       class="options-btn swipe-d-flex justify-content-between">
    @if (editTemplate !== null) {
      <div (click)="action('edit')" class="option-list">
        <ng-template let-show="show" #viewContainerEdit></ng-template>
      </div>
    }
    @if (delTemplate !== null) {
      <div (click)="action('del')" class="option-list">
        <ng-template let-show="show" #viewContainerDel></ng-template>
      </div>
    }
  </div>
  <div [ngClass]="{'left-swipe':(result)}" data-id="{{idElement}}" class="list-swipe swipe-d-flex">
    @if (showMark) {
      <div class="swipe-w-10">
        <ng-container #viewContainerMark></ng-container>
      </div>
    }

    <div (click)="clickItem($event)" [ngClass]="{'swipe-w-90':showMark, 'swipe-w-100':!showMark}">
      @if (customTemplate) {
        <div data-id="{{idElement}}">
          <ng-template #viewContainerCustom>
          </ng-template>
        </div>
      }

      @if (!customTemplate) {
        <div>
          <ng-template #viewContainerCustom></ng-template>
        </div>
      }

    </div>
    <div class="mark"></div>
  </div>
</div>
